module.exports = __webpack_public_path__ + "static/img/exploit7.64b16755.png";